export abstract class TaskConstants {
  public static readonly TITLE_MAX_LENGTH: number = 250;
  public static readonly TITLE_MIN_LENGTH: number = 1;
  public static readonly DESCRIPTION_MAX_LENGTH: number = 1000;
  public static readonly COMMENT_MAX_LENGTH: number = 1000;
}
